import { getCookie, setCookie, removeCookie } from './cookies';

const isAuth0Authenticated = () => {
	return getCookie('PLATEAUTH') === 'true';
};

const userComesFromEmail = () => {
	return (
		window.location.href.includes('utm_medium=email') ||
		window.location.href.includes('utm_medium=mobile-app')
	);
};

const hasEnteredCustomForm = () => {
	const CustomCookie = getCookie('isSubscribed');
	return CustomCookie;
};

export const setUserSubscribedCookie = () => {
	setCookie('isSubscribed', 'true', 30);
};

export const hideModalForADay = () => {
	setCookie('isSubscribed', 'true', 1);
};

/**
 * Checks if user is logged in.
 *
 * @return {boolean} user's logged in state
 */
const isAuthenticated = () => {
	return isAuth0Authenticated() || userComesFromEmail();
};

const isSubscribed = () => {
	return hasEnteredCustomForm() || userComesFromEmail();
};

/**
 * Gets user's data from cookie.
 *
 * @return {Object} user's data
 */
const getUserData = () => {
	return getCookie('PLATEAUSER');
};

const getPermaUserData = () => {
	return getCookie('PERMAUSER');
};

const logout = document.getElementById('logout-a');
if (logout) {
	logout.addEventListener('click', function () {
		removeCookie('PLATEAUTH');
		removeCookie('PLATEAUSER');
		removeCookie('PERMAUSER');
		removeCookie('SuccessCookie');
		removeCookie('Reloaded');
		window.location.href = '/';
	});
}

/**
 * Handles toggle of authentication links on the header based on login state.
 *
 * @param {NodeJS.Timer} intervalTimer NodeJS.Timerpolling timer if available
 */
const initAuthNavigation = (intervalTimer) => {
	const authItems = jQuery('[data-auth-state="true"]');
	const nonAuthItems = jQuery('[data-auth-state="false"]');
	const nonSubItems = jQuery('[data-sub-state="false"]');

	if (isAuthenticated()) {
		nonAuthItems.hide();
		authItems.show();
		nonSubItems.hide();
		if (getUserData() !== false) {
			//set user data to a longer lasting cookie for the data to be used
			setCookie('PERMAUSER', getUserData(), 14);
		}
		if (intervalTimer) {
			/*
			 * If is authenticated we dont need to keep polling because the gate
			 * us removed at this point
			 */
			clearInterval(intervalTimer);
		}
	} else if (isSubscribed()) {
		nonAuthItems.hide();
		authItems.hide();
		nonSubItems.show();
		if (intervalTimer) {
			clearInterval(intervalTimer);
		}
	} else {
		nonAuthItems.show();
		authItems.hide();
		nonSubItems.show();
	}
};

function listenCookieChange(callback, interval = 1000) {
	let lastCookie = document.cookie;
	const intervalTimer = setInterval(() => {
		const cookie = document.cookie;
		if (cookie !== lastCookie) {
			try {
				callback(intervalTimer);
			} finally {
				lastCookie = cookie;
			}
		}
	}, interval);
}

listenCookieChange((intervalTimer) => {
	initAuthNavigation(intervalTimer);
}, 1000);

// Set to window variable for use within the React app.
window.initAuthNavigation = initAuthNavigation;

export {
	isAuthenticated,
	initAuthNavigation,
	getUserData,
	isSubscribed,
	getPermaUserData,
};
